  import { jsx as _jsx } from "@fluentui/react-jsx-runtime/jsx-runtime";
import { assertSlots } from '@fluentui/react-utilities';
/**
 * Render the final JSX of ProgressBar
 */ export const renderProgressBar_unstable = (state)=>{
    assertSlots(state);
    return /*#__PURE__*/ _jsx(state.root, {
        children: state.bar && (state.indeterminateMotion ? /*#__PURE__*/ _jsx(state.indeterminateMotion, {
            children: /*#__PURE__*/ _jsx(state.bar, {})
        }) : /*#__PURE__*/ _jsx(state.bar, {}))
    });
};
